import { getAuthToken } from 'services/authService';
import { getPortals } from './apiActions';

export const getExternalAuthToken = (loginModel) => async (dispatch) => {
    try {
        dispatch({ type: "GET_EXTERNAL_AUTH_TOKEN_LOADING" });
        const data = await getAuthToken("/account/login-external","POST",loginModel);

        if (data) {
            localStorage.setItem('ExternalAuthToken', data);
            dispatch({ type: "GET_EXTERNAL_AUTH_TOKEN_SUCCESS", payload: data.token });
            await dispatch(getPortals());
        } else {
            dispatch({ type: "GET_EXTERNAL_AUTH_TOKEN_FAILURE", payload: "No token received" });
        }
    } catch (error) {
        dispatch({ type: "GET_EXTERNAL_AUTH_TOKEN_FAILURE", payload: error.message });
    }
};